// src/components/Gallery.jsx
import React from 'react';

const uniqueProjects = [
  {
    image: '/assets/work/6.png',
    title: 'PetSuites'
  },
  {
    image: '/assets/work/1.jpeg',
    title: 'Spectrum'
  },
  {
    image: '/assets/work/2.png',
    title: 'JUICE BAR'
  },
  {
    image: '/assets/work/3.png',
    title: 'Unique Project 4'
  },
  {
    image: '/assets/work/4.jpg',
    title: 'Unique Project 5'
  },
  {
    image: '/assets/work/5.jpeg',
    title: 'Unique Project 6'
  }
];

const Galleryimg = () => (
  <section id="unique-projects" className="py">
    <div className="container mx-auto text-center">
      <h2
        className="text-4xl font-extralight mb-4"
        style={{ fontSize: '40px', fontFamily: 'Montserrat, sans-serif', color: '#242528' }}
      >
        Unique designs for unique projects.
      </h2>
      <p
  className="text-lg font-extralight mb-8"
  style={{
    fontSize: '20px',
    fontFamily: 'Montserrat, sans-serif',
    color: '#242528',
    position: 'relative',
    margin: '0 auto',
    marginTop: '40px',
    marginBottom: '40px',
    maxWidth: '60%' // Updated to make it responsive
  }}
>
  While handling high volume accounts for large brands, Rubix remains nimble enough to handle unique projects for small-sized developers.
</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-7xl mx-auto mb-20">
        {uniqueProjects.map((project, index) => (
          <div
            key={index}
            className="overflow-hidden shadow-lg transition-transform transform hover:scale-105 duration-500"
          >
            <img
              src={project.image}
              alt={project.title}
              className="w-full h-80 object-cover object-center"
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Galleryimg;
